import { models } from '../models'


const rewriteSlug = (locale, slug, redirects = null) => {
  /**
   * IMPORTANT!
   * This is a workaround developed 'cause unique slug for locale doesn't work on Strapi
   * It works ONLY if the slug to be redirect is in the redirects list and if the slug
   * itself ends with '-eng'
   */
  if (locale !== 'en' || !slug.endsWith('-eng') || !redirects) return [...slug.split('/')]

  const toBeRedirect = redirects.find(({ source } = {}) => source.endsWith(slug))

  if (!!toBeRedirect) {
    const slugNormalized = slug.replace('-eng', '')
    return [slugNormalized]
  }

  return [...slug.split('/')]
}

export const generateSlug = (attributes, redirects) => {
  if (attributes.homepage) return false

  if (!attributes.slug) return []

  if (!!attributes.parent) return [attributes.parent, ...rewriteSlug(attributes.locale, attributes.slug, redirects)]

  return [...rewriteSlug(attributes.locale, attributes.slug, redirects)]
}

const generatePageIndex = (sections) => {
  return sections.filter(s => s.indexLabel)
    .map(section => {
      const target = section.indexLabel.toLowerCase().replace(' ', '-')
      return {
        label: section.indexLabel,
        target
      }
    })
}


export const normalizeData = async (dataToNormalize = [], locale, additionalData) => {
  const data = []
  for (const section of dataToNormalize) {
    let _section = section
    const type = section.type ? section.type.replace(/-/g, '') : null
    if (models[type]) {
      _section = await models[type](_section, locale, additionalData)
    }
    data.push(_section)
  }

  return data
}


export const normalizeMetadata = async (data, options) => {
  const metadata = data.seo || {}
  metadata.defaultSeo = {}
  metadata.defaultSeo.title = metadata.metaTitle || `${data.title}${options.metaDefaultTitle ? ' | ' + options.metaDefaultTitle  : ''}`
  metadata.defaultSeo.description = metadata.metaDescription  || data.excerpt  || options.metaDefaultDescription || ''
  metadata.defaultSeo.image = metadata.metaImage || {}

  return metadata
}

const getTranslatedUrls = (localizations, data, redirects) => {
  let i18nUrls = []
  const currentUrl = generateSlug(data, redirects)
  i18nUrls = [{
    href: `/${currentUrl ? currentUrl.join('/') : ''}`,
    locale: data.locale
  }]

  if (!localizations.data || localizations.data.length === 0) return i18nUrls

  const localizedUrls = localizations.data.map(({ attributes }) => {
    const { locale } = attributes
    const url = generateSlug(attributes, redirects)
    const localeUrl = {
      href: `/${url ? url.join('/') : ''}`,
      locale
    }
    return localeUrl
  })

  i18nUrls = [...i18nUrls, ...localizedUrls]
  return i18nUrls
}

export const normalizeAdditionalData = async (data, redirects) => {
  const {
    index,
    darkTheme,
    slug,
    homepage = false,
    removeFooter = false,
    title,
    scenarios = null,
    services = null,
    localizations,
  } = data

  const i18nUrls = getTranslatedUrls(localizations, data, redirects)

  const page = {
    slug,
    homepage,
    pageDarkTheme: !!darkTheme,
    removeFooter,
    title,
    index: index ? generatePageIndex(data.sections) : false,
    i18nUrls
  }

  const additionalData = {
    page,
    scenarios,
    services,
  }


  return additionalData
}


export const normalizeResults = (data) => {
  if (!data || data.length === 0) return []
  const clusteredData = data.reduce((acc, curr) => {
    const cluster = curr.contentTypeLabel
    if (!acc[cluster]) acc[cluster] = []

    const link = {
      locale: curr.locale,
      href: curr.homepage ? '/' : `/${generateSlug(curr).join('/')}`
    }

    Object.assign(curr, { link })

    acc[cluster].push(curr)
    return acc
  }, {})

  const formattedData = Object.entries(clusteredData).map(([cluster, items]) => ({
    cluster,
    items
  }))

  return formattedData
}
